import { DialogDescription } from '@radix-ui/react-dialog';
import { User } from 'lucide-react';
import { useState } from 'react';

import { Button } from '@/components/ui/Button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogTitle,
  DialogHeader,
} from '@/components/ui/Dialog';
import { useGetUserById } from '@/hooks/useGetUserById';

interface UserViewerDialogProps {
  userId: number;
}

export function UserViewerDialog({ userId }: UserViewerDialogProps) {
  const [isUserModalOpen, setIsUserModalOpen] = useState(false);

  const { user, isLoading } = useGetUserById(userId);
  function handleViewUser() {
    if (user) {
      setIsUserModalOpen(true);
    }
  }

  return (
    <div className="flex w-2/3 flex-row items-center justify-between">
      <span>{userId}</span>
      <Button
        variant="ghost"
        size="sm"
        onClick={() => handleViewUser()}
        className="h-6 w-6 p-0 hover:bg-white"
      >
        <User className="h-3 w-3" />
      </Button>

      {isUserModalOpen && user && !isLoading && (
        <Dialog open={isUserModalOpen} onOpenChange={setIsUserModalOpen}>
          <DialogContent>
            <DialogHeader className="flex flex-row items-center justify-between">
              <DialogTitle>User Information</DialogTitle>
              <DialogClose />
            </DialogHeader>
            <DialogDescription className="sr-only">
              Este modal exibe os dados do usuário selecionado.
            </DialogDescription>

            <div className="grid grid-cols-2 gap-4 text-sm">
              <div>
                <p className="text-muted-foreground">ID</p>
                <p className="font-medium">{user.id.toString()}</p>
              </div>

              <div>
                <p className="text-muted-foreground">Status</p>
                <p className="text-sm">
                  <span
                    className={`inline-flex items-center rounded-full px-2 py-1 text-xs font-medium ${
                      user.status.name === 'Active'
                        ? 'bg-green-100 text-green-800'
                        : 'bg-red-100 text-red-800'
                    }`}
                  >
                    {user.status.name}
                  </span>
                </p>
              </div>

              <div>
                <p className="text-muted-foreground">Firstname</p>
                <p className="font-medium">{user.firstName}</p>
              </div>

              <div>
                <p
                  className={`text-muted-foreground ${user.lastName ? '' : 'hidden'}`}
                >
                  Lastname
                </p>
                <p className="font-medium">{user.lastName}</p>
              </div>

              {user.customer && (
                <>
                  <div>
                    <p className="text-muted-foreground">Customer ID</p>
                    <p className="font-medium">{user.customer.id}</p>
                  </div>
                  <div>
                    <p className="text-muted-foreground">Customer Name</p>
                    <p className="font-medium">{user.customer.name}</p>
                  </div>
                </>
              )}

              <div className="col-span-2">
                <p className="text-muted-foreground">Email</p>
                <p className="font-medium">{user.email}</p>
              </div>

              <div className="col-span-2">
                <p className="text-muted-foreground">Role</p>
                <p className="font-medium">{user.role.name}</p>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
}
